// Submit loading state
// When a form is submitted, disables the submit button(s), applies .btn--loading,
// sets aria-busy="true", and shows the data-loading-text label.
//
// For text-only buttons (e.g. the Devise login submit) the existing label is
// replaced with the loading text. For buttons containing element children
// (e.g. role-selection cards with an icon + description block), the children
// remain in place at the same size and a translucent overlay is layered on top
// so the user keeps the role details visible while the action is in flight.
//
// Also disables sibling role cards on role-selection so only one card is in-flight.

document.addEventListener('submit', (event) => {
  const form = event.target
  if (!(form instanceof HTMLFormElement)) return

  // On role-selection: dim all other role cards so the user can't double-submit.
  const allRoles = document.querySelectorAll('.rp__role')
  if (allRoles.length > 0) {
    allRoles.forEach((roleEl) => {
      if (!roleEl.contains(form)) {
        roleEl.classList.add('rp__role--disabled')
      }
    })
  }

  // Disable and visually indicate loading on this form's submit buttons.
  const buttons = form.querySelectorAll('button[type="submit"], button:not([type]), input[type="submit"]')
  buttons.forEach((btn) => {
    btn.disabled = true
    btn.setAttribute('aria-busy', 'true')
    btn.classList.add('btn--loading')
    const loadingText = btn.dataset.loadingText
    if (!loadingText) return

    if (btn.firstElementChild) {
      // Button has structured content (e.g. a role card). Keep it visible at the
      // same size and overlay the loading state on top.
      btn.classList.add('btn--loading-with-overlay')
      const overlay = document.createElement('span')
      overlay.className = 'btn__loading-overlay'
      overlay.textContent = loadingText
      btn.appendChild(overlay)
    } else {
      // Plain text button — swap the label inline.
      btn.dataset.originalHtml = btn.innerHTML
      btn.textContent = loadingText
    }
  })
}, true)
